import { ScaledImage } from 'types';
import { IEntityTypes } from './labels';
import { Deal } from 'partnerClient/backend/types';
import { IAffiliate } from 'partnerClient/explore/types';
import { ICashbackType } from 'partnerClient/shoppingCart/types';

export enum IProductTypes {
  AFFILIATE_ONLINE = 'AFFILIATE_ONLINE',
  AFFILIATE_OFFLINE = 'AFFILIATE_OFFLINE',
  DEAL = 'DEAL',
  GIFT_CARD = 'GIFT_CARD'
}

export interface ISearchParams {
  page: number;
  size?: number;
  sort?: string | string[];
  query?: string;
  labels?: string[];
  searchableTypes?: IProductTypes;
  businessProfileIds?: string[];
  priceFrom?: number;
  priceTo?: number;
  lastChance?: boolean;
  cashbackFrom?: number;
  cashbackTo?: number;
}

export interface ISearchProductBPData {
  logo: string;
  name: string;
  id: number;
  description: string;
  picture: ScaledImage;
}

export interface ICashback {
  type: ICashbackType;
  value: number;
}

export interface ISearchProduct {
  description: string;
  businessProfileData: ISearchProductBPData;
  name: string;
  picture: ScaledImage;
  productId: number;
  productType: IEntityTypes;
  searchableTypes: IProductTypes[];
  logo: string;
  slug: string;
  cashbackPercent: number;
  dealData: Deal;
  affiliateData: IAffiliate;
  highestCashback?: ICashback;
}
